export const getTarget = tt => (tt?.target === 'Sim' ? '_blank' : '_self');

export const getRel = tt => (tt?.rel === 'Sim' ? 'noreferrer nofollow' : '');

export const getHighlight = tt => (tt?.highlight === 'true' ? true : false);
